import { render, staticRenderFns } from "./studentAudioItem.vue?vue&type=template&id=62caf2c0&scoped=true"
import script from "./studentAudioItem.vue?vue&type=script&lang=js"
export * from "./studentAudioItem.vue?vue&type=script&lang=js"
import style0 from "./studentAudioItem.vue?vue&type=style&index=0&id=62caf2c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62caf2c0",
  null
  
)

export default component.exports